// types
export type { TypeModalMobileProps } from './types'

// hooks
export { useSwipeEffect } from './hooks'
